import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux'

class LeftNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: this.props.activeKey,
            propertyType: this.props.propertyType,
        };
    }

    render() {
        return (
            <div className="leftNav">
                <ul>
                    <li>
                        <Link to={`/edge/${this.state.propertyType}/dashboard/` + this.props.location.search} className={this.state.activeKey === "1" ? 'activeNav' : ''} onClick={() => {
                            this.setState({ activeKey: "1" });
                            // var path = appConfigs.appPath+`/dashboard/`+window.location.search;
                            // window.location.href = path;
                            // // this.props.history.push({
                            // //   pathname:
                            // //     `/`,
                            // // });
                            this.props.dispatch({
                                type: 'HIDE_FILTER_DIV',
                                payload: { showFilterDiv: false }
                            })
                        }}>
                            <p className="text-center">
                                <img
                                    alt="Dashbord Icon"
                                    src={
                                        this.state.activeKey === "1"
                                            ? "/images/dashboard_active.png"
                                            : "/images/dashboard.png"
                                    }
                                />
                            </p>
                            <p className="text-center">Dashboard</p>
                        </Link>
                    </li>
                    <li>
                        <Link to={`/edge/${this.state.propertyType}/region/` + this.props.location.search} className={this.state.activeKey === "2" ? 'activeNav' : ''} onClick={() => {
                            this.setState({ activeKey: "2" });
                            this.props.dispatch({
                                type: 'HIDE_FILTER_DIV',
                                payload: { showFilterDiv: false }
                            });
                            // this.props.appConfigs.appPath+history.push(
                            //   `/region/1`
                            // );
                            // var path = appConfigs.appPath+`/region/`+window.location.search;
                            // window.location.href = path;
                        }}>
                            <p className="text-center">
                                <img
                                    alt="Region Icon"
                                    src={
                                        this.state.activeKey === "2"
                                            ? "/images/region_active.png"
                                            : "/images/region.png"
                                    }
                                />
                            </p>
                            <p className="text-center">Region</p>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to={`/edge/${this.state.propertyType}/developer/${this.props.location.search}`} className={this.state.activeKey === "3" ? "activeNav" : ""} onClick={() => {
                                this.setState({ activeKey: "3" });
                                this.props.dispatch({
                                    type: 'HIDE_FILTER_DIV',
                                    payload: { showFilterDiv: false }
                                });
                            }}
                        >
                            <p className="text-center">
                                <img
                                    alt="Developer Icon"
                                    src={
                                        this.state.activeKey === "3"
                                            ? "/images/developer_active.png"
                                            : "/images/developer.png"
                                    }
                                />
                            </p>
                            <p className="text-center">Developer</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Owner Icon" src="/edge/images/owner.png" />
                            </p>
                            <p className="text-center">Owner</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Asset Icon" src="/edge/images/asset.png" />
                            </p>
                            <p className="text-center">Asset</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Occupier Icon" src="/edge/images/occupier.png" />
                            </p>
                            <p className="text-center">Occupier</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Map Icon" src="/edge/images/map.png" />
                            </p>
                            <p className="text-center">Map</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Custom Icon" src="/edge/images/custom.png" />
                            </p>
                            <p className="text-center">Custom</p>
                        </Link>
                    </li>
                    <li>
                        <Link to="/">
                            <p className="text-center">
                                <img alt="Transactions Icon" src="/edge/images/transactions.png" />
                            </p>
                            <p className="text-center">Transaction</p>
                        </Link>
                    </li>
                </ul>
            </div>
        );
    }
}

export default withRouter(connect(null, null)(LeftNavbar));
// export default LeftNavbar;
